import React from "react";

import { IgAccordion, IgTypography } from "@intelligems/ig-theme";
import { CartTransformType } from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { useTheme } from "@mui/styles";
import { useGetExperiencesList } from "@src/api/experiences-list/get-experiences-list";
import { theme } from "@src/theme";
import { Json } from "@src/utils/json";

interface ExperienceIdsSectionProps {
  experiences:
    | CartTransformType["experiences"]
    | CartTransformType["experiments"];
}

const ExperimentIdsSection = ({ experiences }: ExperienceIdsSectionProps) => {
  const experienceList = useGetExperiencesList({ category: "experiment" });
  const theme = useTheme();
  if (!experienceList.data) return null;

  return (
    <>
      <IgTypography sx={{ fontWeight: 600 }}>Experiment Metadata:</IgTypography>
      <br />
      <IgTypography
        sx={{
          color:
            experiences && experiences.length
              ? theme.palette.text.tonal.success
              : theme.palette.text.tonal.error,
          marginLeft: "20px",
        }}
      >
        {experiences && experiences.length
          ? `Experiences linked to Cart Transform: ${experiences
              .map(
                (e) =>
                  experienceList.data.experiencesList.find(
                    (el) => el.id === e.id
                  )?.name
              )
              .join(", ")}`
          : "No experiences linked to Cart Transform"}
      </IgTypography>
      <br />
      {experiences && experiences.length ? (
        <Grid item sx={{ marginLeft: "20px" }}>
          <Json name={"experiments"} data={experiences[0]} />
        </Grid>
      ) : null}
      {/*{experiences.map((experiment) => (*/}
      {/*  <Grid item key={experiment.id} sx={{ marginLeft: "40px" }}>*/}
      {/*    <IgCopyTextTypography text={experiment.id} />*/}
      {/*    <br />*/}
      {/*    <IgTypography sx={{ marginLeft: "20px", fontWeight: 600 }}>*/}
      {/*      Test Group Ids:*/}
      {/*    </IgTypography>*/}
      {/*    <br />*/}
      {/*    {experiment.testGroupIds.map((id) => (*/}
      {/*      <>*/}
      {/*        <IgCopyTextTypography*/}
      {/*          key={id}*/}
      {/*          typographyProps={{ sx: { marginLeft: "40px" } }}*/}
      {/*          text={id}*/}
      {/*        />*/}
      {/*        <br />*/}
      {/*      </>*/}
      {/*    ))}*/}
      {/*  </Grid>*/}
      {/*))}*/}
    </>
  );
};

interface CartTransformAccordionProps {
  cartTransform: CartTransformType;
  index: number;
  totalCount: number;
}

export const CartTransformAccordion = ({
  cartTransform,
  index,
  totalCount,
}: CartTransformAccordionProps) => {
  return (
    <Grid item sx={{ width: "100%" }}>
      <IgAccordion
        title={`Cart Transform ${totalCount > 1 ? ` ${index + 1}` : ""}`}
      >
        <Grid container>
          <IgTypography sx={{ fontWeight: 600 }}>Details:</IgTypography>
          <br />
          <IgTypography
            sx={{
              marginLeft: "20px",
              color: cartTransform.isPricingFunctionId
                ? theme.palette.text.tonal.success
                : theme.palette.text.tonal.error,
            }}
          >
            {cartTransform.isPricingFunctionId
              ? "Correctly linked to Intelligems Pricing Function"
              : "Not linked to Intelligems Pricing Function"}
          </IgTypography>
          <br />
          <IgTypography>
            <IgTypography sx={{ fontWeight: 600 }}>Mode: </IgTypography>{" "}
            {cartTransform.cartTransformMode || "NOT SET"}
          </IgTypography>
          <br />
          <ExperimentIdsSection
            experiences={
              cartTransform.experiences || cartTransform.experiments || []
            }
          />
        </Grid>
      </IgAccordion>
    </Grid>
  );
};
